module.exports = __webpack_public_path__ + "img/icon_restart.38123a7a.svg";